import { render, staticRenderFns } from "./PopupRiskInfoBsgs1.vue?vue&type=template&id=29527a7e&scoped=true&"
import script from "./PopupRiskInfoBsgs1.vue?vue&type=script&lang=js&"
export * from "./PopupRiskInfoBsgs1.vue?vue&type=script&lang=js&"
import style0 from "./PopupRiskInfoBsgs1.vue?vue&type=style&index=0&id=29527a7e&prod&lang=scss&scoped=true&"
import style1 from "./PopupRiskInfoBsgs1.vue?vue&type=style&index=1&id=29527a7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29527a7e",
  null
  
)

export default component.exports